import { useCallback } from "react";
import { useMutation } from "convex/react";
import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

/**
 * Reports a completed submittal download as the activation milestone. Fire-and-forget: the
 * download already happened, so a failure here must never surface to the user.
 */
export function useRecordExportDownloaded() {
  const record = useMutation(api.onboarding.recordExportDownloaded);
  return useCallback(
    (submittalId: Id<"specPilotSubmittals">) => {
      record({ submittalId }).catch((error: unknown) => {
        console.warn("Could not record export download", error);
      });
    },
    [record]
  );
}
